import { decodeJwt } from 'jose';

import { serverNowSeconds } from './clock.util';

const SKEW_SECONDS = 60;

export function isAccessTokenStale(token: string | null | undefined): boolean {
  if (!token) return true;
  try {
    const { exp } = decodeJwt(token);
    if (!exp) return true;
    return exp <= serverNowSeconds() + SKEW_SECONDS;
  } catch {
    return true; // undecodable → refresh (fail-safe)
  }
}

export function isAnonymousToken(token: string | null | undefined): boolean {
  if (!token) return false;
  try {
    return (decodeJwt(token) as { email?: string }).email === 'undefined';
  } catch {
    return false;
  }
}

/** Returns the `exp` claim of the token in epoch seconds, or null if undecodable / missing. */
export function accessTokenExpSeconds(token: string | null | undefined): number | null {
  if (!token) return null;
  try {
    const { exp } = decodeJwt(token);
    return exp ?? null;
  } catch {
    return null;
  }
}
